 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLCH00_FM01_HALFTITLE from '@/components/xhtml/ch00_fm01_halftitle'
 import XHTMLCH00_FM02_TITLE from '@/components/xhtml/ch00_fm02_title'
 import XHTMLCH00_FM03_COPYRIGHT from '@/components/xhtml/ch00_fm03_copyright'
 import XHTMLCH00_FM04_DEDICATION from '@/components/xhtml/ch00_fm04_dedication'
 import XHTMLCH00_FM05_CONTENTS from '@/components/xhtml/ch00_fm05_contents'
 import XHTMLCH00_FM06_INTRODUCTION from '@/components/xhtml/ch00_fm06_introduction'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08_CONCLUSION from '@/components/xhtml/ch08_conclusion'
 import XHTMLCH09_GUIDE from '@/components/xhtml/ch09_guide'
 import XHTMLCH10_NOTES from '@/components/xhtml/ch10_notes'
 import XHTMLCH11_ACKNOWLEDGMENTS from '@/components/xhtml/ch11_acknowledgments'
 import XHTMLCH12_INDEX from '@/components/xhtml/ch12_index'
 import XHTMLCH13_AUTHOR from '@/components/xhtml/ch13_author'
 import XHTMLCH14_BM01 from '@/components/xhtml/ch14_bm01'
 import XHTMLCH15_READER from '@/components/xhtml/ch15_reader'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/ch00_fm05_contents",
 			"name" : "xhtml/ch00_fm05_contents",
 			"component" : XHTMLCH00_FM05_CONTENTS
 		},
 		{
 			"path" : "/xhtml/ch00_fm06_introduction",
 			"name" : "xhtml/ch00_fm06_introduction",
 			"component" : XHTMLCH00_FM06_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js